/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminCreateIndividualMatchRequest,
  AdminCreateMatchGroupResponse,
  AdminCreateTeamMatchRequest,
  AdminEditMatchProgressRequest,
  AdminEditMatchProgressResponse,
  AdminMatchExportResponse,
  BatchImportMatchesParams,
  BodyBatchImportMatches,
  GetAdminMatchById200,
  GetAdminMatchExportParams,
  GetAdminMatchesParams,
  GetMatchGroupProjectPlan200,
  GetOrganizationAdminMatchesParams,
  GetProfessionalAdminMatchesParams,
  GetProjectAdminMatchesParams,
  HTTPValidationError,
  MatchesDataResponse,
} from './platformapi.schemas';

import getAdminMatchesMutator from '../custom-axios-instance';
import batchImportMatchesMutator from '../custom-axios-instance';
import adminDeleteMatchGroupMutator from '../custom-axios-instance';
import getAdminMatchExportMutator from '../custom-axios-instance';
import adminCreateIndividualMatchMutator from '../custom-axios-instance';
import getOrganizationAdminMatchesMutator from '../custom-axios-instance';
import getProfessionalAdminMatchesMutator from '../custom-axios-instance';
import adminEditMatchProgressMutator from '../custom-axios-instance';
import getProjectAdminMatchesMutator from '../custom-axios-instance';
import adminCreateTeamMatchMutator from '../custom-axios-instance';
import getAdminMatchByIdMutator from '../custom-axios-instance';
import getMatchGroupProjectPlanMutator from '../custom-axios-instance';

/**
 * @summary Get Admin Matches
 */
export const getAdminMatches = (params?: GetAdminMatchesParams, signal?: AbortSignal) => {
  return getAdminMatchesMutator<MatchesDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAdminMatchesQueryKey = (params?: GetAdminMatchesParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/matches/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminMatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMatchesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatches>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminMatchesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMatches>>> = ({ signal }) =>
    getAdminMatches(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMatches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMatches>>>;
export type GetAdminMatchesQueryError = void | HTTPValidationError;

export function useGetAdminMatches<
  TData = Awaited<ReturnType<typeof getAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetAdminMatchesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatches>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMatches>>,
          TError,
          Awaited<ReturnType<typeof getAdminMatches>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminMatches<
  TData = Awaited<ReturnType<typeof getAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMatchesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatches>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMatches>>,
          TError,
          Awaited<ReturnType<typeof getAdminMatches>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminMatches<
  TData = Awaited<ReturnType<typeof getAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMatchesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatches>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Admin Matches
 */

export function useGetAdminMatches<
  TData = Awaited<ReturnType<typeof getAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMatchesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatches>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminMatchesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Batch Import Matches
 */
export const batchImportMatches = (
  bodyBatchImportMatches: BodyBatchImportMatches,
  params?: BatchImportMatchesParams,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, bodyBatchImportMatches.file);

  return batchImportMatchesMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/batch-import`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    params,
    signal,
  });
};

export const getBatchImportMatchesMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchImportMatches>>,
    TError,
    { data: BodyBatchImportMatches; params?: BatchImportMatchesParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchImportMatches>>,
  TError,
  { data: BodyBatchImportMatches; params?: BatchImportMatchesParams },
  TContext
> => {
  const mutationKey = ['batchImportMatches'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchImportMatches>>,
    { data: BodyBatchImportMatches; params?: BatchImportMatchesParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return batchImportMatches(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchImportMatchesMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchImportMatches>>
>;
export type BatchImportMatchesMutationBody = BodyBatchImportMatches;
export type BatchImportMatchesMutationError = void | HTTPValidationError;

/**
 * @summary Batch Import Matches
 */
export const useBatchImportMatches = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchImportMatches>>,
      TError,
      { data: BodyBatchImportMatches; params?: BatchImportMatchesParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchImportMatches>>,
  TError,
  { data: BodyBatchImportMatches; params?: BatchImportMatchesParams },
  TContext
> => {
  const mutationOptions = getBatchImportMatchesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Admin Delete Match Group
 */
export const adminDeleteMatchGroup = (matchGroupId: number) => {
  return adminDeleteMatchGroupMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/delete/${matchGroupId}`,
    method: 'DELETE',
  });
};

export const getAdminDeleteMatchGroupMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteMatchGroup>>,
    TError,
    { matchGroupId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteMatchGroup>>,
  TError,
  { matchGroupId: number },
  TContext
> => {
  const mutationKey = ['adminDeleteMatchGroup'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteMatchGroup>>,
    { matchGroupId: number }
  > = (props) => {
    const { matchGroupId } = props ?? {};

    return adminDeleteMatchGroup(matchGroupId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteMatchGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteMatchGroup>>
>;

export type AdminDeleteMatchGroupMutationError = void | HTTPValidationError;

/**
 * @summary Admin Delete Match Group
 */
export const useAdminDeleteMatchGroup = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteMatchGroup>>,
      TError,
      { matchGroupId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteMatchGroup>>,
  TError,
  { matchGroupId: number },
  TContext
> => {
  const mutationOptions = getAdminDeleteMatchGroupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Admin Match Export
 */
export const getAdminMatchExport = (params?: GetAdminMatchExportParams, signal?: AbortSignal) => {
  return getAdminMatchExportMutator<AdminMatchExportResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/export-matches`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAdminMatchExportQueryKey = (params?: GetAdminMatchExportParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/matches/export-matches`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminMatchExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMatchExport>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMatchExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchExport>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminMatchExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMatchExport>>> = ({ signal }) =>
    getAdminMatchExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMatchExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminMatchExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminMatchExport>>
>;
export type GetAdminMatchExportQueryError = void | HTTPValidationError;

export function useGetAdminMatchExport<
  TData = Awaited<ReturnType<typeof getAdminMatchExport>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetAdminMatchExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMatchExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminMatchExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminMatchExport<
  TData = Awaited<ReturnType<typeof getAdminMatchExport>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMatchExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMatchExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminMatchExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminMatchExport<
  TData = Awaited<ReturnType<typeof getAdminMatchExport>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMatchExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Admin Match Export
 */

export function useGetAdminMatchExport<
  TData = Awaited<ReturnType<typeof getAdminMatchExport>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMatchExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminMatchExportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Admin Create Individual Match
 */
export const adminCreateIndividualMatch = (
  adminCreateIndividualMatchRequest: AdminCreateIndividualMatchRequest,
  signal?: AbortSignal,
) => {
  return adminCreateIndividualMatchMutator<AdminCreateMatchGroupResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/individual`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: adminCreateIndividualMatchRequest,
    signal,
  });
};

export const getAdminCreateIndividualMatchMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateIndividualMatch>>,
    TError,
    { data: AdminCreateIndividualMatchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateIndividualMatch>>,
  TError,
  { data: AdminCreateIndividualMatchRequest },
  TContext
> => {
  const mutationKey = ['adminCreateIndividualMatch'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateIndividualMatch>>,
    { data: AdminCreateIndividualMatchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateIndividualMatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateIndividualMatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateIndividualMatch>>
>;
export type AdminCreateIndividualMatchMutationBody = AdminCreateIndividualMatchRequest;
export type AdminCreateIndividualMatchMutationError = void | HTTPValidationError;

/**
 * @summary Admin Create Individual Match
 */
export const useAdminCreateIndividualMatch = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateIndividualMatch>>,
      TError,
      { data: AdminCreateIndividualMatchRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateIndividualMatch>>,
  TError,
  { data: AdminCreateIndividualMatchRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateIndividualMatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Organization Admin Matches
 */
export const getOrganizationAdminMatches = (
  organizationId: number,
  params?: GetOrganizationAdminMatchesParams,
  signal?: AbortSignal,
) => {
  return getOrganizationAdminMatchesMutator<MatchesDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/organizations/${organizationId}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetOrganizationAdminMatchesQueryKey = (
  organizationId?: number,
  params?: GetOrganizationAdminMatchesParams,
) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/matches/organizations/${organizationId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationAdminMatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  params?: GetOrganizationAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAdminMatches>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationAdminMatchesQueryKey(organizationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationAdminMatches>>> = ({
    signal,
  }) => getOrganizationAdminMatches(organizationId, params, signal);

  return { queryKey, queryFn, enabled: !!organizationId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationAdminMatches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationAdminMatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationAdminMatches>>
>;
export type GetOrganizationAdminMatchesQueryError = void | HTTPValidationError;

export function useGetOrganizationAdminMatches<
  TData = Awaited<ReturnType<typeof getOrganizationAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  params: undefined | GetOrganizationAdminMatchesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAdminMatches>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAdminMatches>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationAdminMatches>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationAdminMatches<
  TData = Awaited<ReturnType<typeof getOrganizationAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  params?: GetOrganizationAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAdminMatches>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAdminMatches>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationAdminMatches>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationAdminMatches<
  TData = Awaited<ReturnType<typeof getOrganizationAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  params?: GetOrganizationAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAdminMatches>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Admin Matches
 */

export function useGetOrganizationAdminMatches<
  TData = Awaited<ReturnType<typeof getOrganizationAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  params?: GetOrganizationAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAdminMatches>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationAdminMatchesQueryOptions(organizationId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Professional Admin Matches
 */
export const getProfessionalAdminMatches = (
  professionalId: number,
  params?: GetProfessionalAdminMatchesParams,
  signal?: AbortSignal,
) => {
  return getProfessionalAdminMatchesMutator<MatchesDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/professional/${professionalId}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProfessionalAdminMatchesQueryKey = (
  professionalId?: number,
  params?: GetProfessionalAdminMatchesParams,
) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/matches/professional/${professionalId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProfessionalAdminMatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfessionalAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  professionalId: number,
  params?: GetProfessionalAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalAdminMatches>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProfessionalAdminMatchesQueryKey(professionalId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfessionalAdminMatches>>> = ({
    signal,
  }) => getProfessionalAdminMatches(professionalId, params, signal);

  return { queryKey, queryFn, enabled: !!professionalId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfessionalAdminMatches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProfessionalAdminMatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfessionalAdminMatches>>
>;
export type GetProfessionalAdminMatchesQueryError = void | HTTPValidationError;

export function useGetProfessionalAdminMatches<
  TData = Awaited<ReturnType<typeof getProfessionalAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  professionalId: number,
  params: undefined | GetProfessionalAdminMatchesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalAdminMatches>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalAdminMatches>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalAdminMatches>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfessionalAdminMatches<
  TData = Awaited<ReturnType<typeof getProfessionalAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  professionalId: number,
  params?: GetProfessionalAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalAdminMatches>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalAdminMatches>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalAdminMatches>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfessionalAdminMatches<
  TData = Awaited<ReturnType<typeof getProfessionalAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  professionalId: number,
  params?: GetProfessionalAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalAdminMatches>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Professional Admin Matches
 */

export function useGetProfessionalAdminMatches<
  TData = Awaited<ReturnType<typeof getProfessionalAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  professionalId: number,
  params?: GetProfessionalAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalAdminMatches>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProfessionalAdminMatchesQueryOptions(professionalId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Admin Edit Match Progress
 */
export const adminEditMatchProgress = (
  matchGroupId: number,
  adminEditMatchProgressRequest: AdminEditMatchProgressRequest,
) => {
  return adminEditMatchProgressMutator<AdminEditMatchProgressResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/progress/${matchGroupId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: adminEditMatchProgressRequest,
  });
};

export const getAdminEditMatchProgressMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEditMatchProgress>>,
    TError,
    { matchGroupId: number; data: AdminEditMatchProgressRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminEditMatchProgress>>,
  TError,
  { matchGroupId: number; data: AdminEditMatchProgressRequest },
  TContext
> => {
  const mutationKey = ['adminEditMatchProgress'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminEditMatchProgress>>,
    { matchGroupId: number; data: AdminEditMatchProgressRequest }
  > = (props) => {
    const { matchGroupId, data } = props ?? {};

    return adminEditMatchProgress(matchGroupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEditMatchProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminEditMatchProgress>>
>;
export type AdminEditMatchProgressMutationBody = AdminEditMatchProgressRequest;
export type AdminEditMatchProgressMutationError = void | HTTPValidationError;

/**
 * @summary Admin Edit Match Progress
 */
export const useAdminEditMatchProgress = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminEditMatchProgress>>,
      TError,
      { matchGroupId: number; data: AdminEditMatchProgressRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminEditMatchProgress>>,
  TError,
  { matchGroupId: number; data: AdminEditMatchProgressRequest },
  TContext
> => {
  const mutationOptions = getAdminEditMatchProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Project Admin Matches
 */
export const getProjectAdminMatches = (
  projectId: number,
  params?: GetProjectAdminMatchesParams,
  signal?: AbortSignal,
) => {
  return getProjectAdminMatchesMutator<MatchesDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/projects/${projectId}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProjectAdminMatchesQueryKey = (
  projectId?: number,
  params?: GetProjectAdminMatchesParams,
) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/matches/projects/${projectId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProjectAdminMatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  params?: GetProjectAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectAdminMatches>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectAdminMatchesQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectAdminMatches>>> = ({ signal }) =>
    getProjectAdminMatches(projectId, params, signal);

  return { queryKey, queryFn, enabled: !!projectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectAdminMatches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectAdminMatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectAdminMatches>>
>;
export type GetProjectAdminMatchesQueryError = void | HTTPValidationError;

export function useGetProjectAdminMatches<
  TData = Awaited<ReturnType<typeof getProjectAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  params: undefined | GetProjectAdminMatchesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectAdminMatches>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectAdminMatches>>,
          TError,
          Awaited<ReturnType<typeof getProjectAdminMatches>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectAdminMatches<
  TData = Awaited<ReturnType<typeof getProjectAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  params?: GetProjectAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectAdminMatches>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectAdminMatches>>,
          TError,
          Awaited<ReturnType<typeof getProjectAdminMatches>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectAdminMatches<
  TData = Awaited<ReturnType<typeof getProjectAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  params?: GetProjectAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectAdminMatches>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Project Admin Matches
 */

export function useGetProjectAdminMatches<
  TData = Awaited<ReturnType<typeof getProjectAdminMatches>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  params?: GetProjectAdminMatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectAdminMatches>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectAdminMatchesQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Admin Create Team Match
 */
export const adminCreateTeamMatch = (
  adminCreateTeamMatchRequest: AdminCreateTeamMatchRequest,
  signal?: AbortSignal,
) => {
  return adminCreateTeamMatchMutator<AdminCreateMatchGroupResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/team`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: adminCreateTeamMatchRequest,
    signal,
  });
};

export const getAdminCreateTeamMatchMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateTeamMatch>>,
    TError,
    { data: AdminCreateTeamMatchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateTeamMatch>>,
  TError,
  { data: AdminCreateTeamMatchRequest },
  TContext
> => {
  const mutationKey = ['adminCreateTeamMatch'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateTeamMatch>>,
    { data: AdminCreateTeamMatchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateTeamMatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateTeamMatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateTeamMatch>>
>;
export type AdminCreateTeamMatchMutationBody = AdminCreateTeamMatchRequest;
export type AdminCreateTeamMatchMutationError = void | HTTPValidationError;

/**
 * @summary Admin Create Team Match
 */
export const useAdminCreateTeamMatch = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateTeamMatch>>,
      TError,
      { data: AdminCreateTeamMatchRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateTeamMatch>>,
  TError,
  { data: AdminCreateTeamMatchRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateTeamMatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Admin Match By Id
 */
export const getAdminMatchById = (matchGroupId: number, signal?: AbortSignal) => {
  return getAdminMatchByIdMutator<GetAdminMatchById200>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/${matchGroupId}`,
    method: 'GET',
    signal,
  });
};

export const getGetAdminMatchByIdQueryKey = (matchGroupId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/matches/${matchGroupId}`] as const;
};

export const getGetAdminMatchByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMatchById>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchById>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminMatchByIdQueryKey(matchGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMatchById>>> = ({ signal }) =>
    getAdminMatchById(matchGroupId, signal);

  return { queryKey, queryFn, enabled: !!matchGroupId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMatchById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminMatchByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminMatchById>>
>;
export type GetAdminMatchByIdQueryError = void | HTTPValidationError;

export function useGetAdminMatchById<
  TData = Awaited<ReturnType<typeof getAdminMatchById>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMatchById>>,
          TError,
          Awaited<ReturnType<typeof getAdminMatchById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminMatchById<
  TData = Awaited<ReturnType<typeof getAdminMatchById>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMatchById>>,
          TError,
          Awaited<ReturnType<typeof getAdminMatchById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminMatchById<
  TData = Awaited<ReturnType<typeof getAdminMatchById>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Admin Match By Id
 */

export function useGetAdminMatchById<
  TData = Awaited<ReturnType<typeof getAdminMatchById>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminMatchByIdQueryOptions(matchGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Match Group Project Plan
 */
export const getMatchGroupProjectPlan = (matchGroupId: number, signal?: AbortSignal) => {
  return getMatchGroupProjectPlanMutator<GetMatchGroupProjectPlan200>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/matches/${matchGroupId}/project-plan`,
    method: 'GET',
    signal,
  });
};

export const getGetMatchGroupProjectPlanQueryKey = (matchGroupId?: number) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/matches/${matchGroupId}/project-plan`,
  ] as const;
};

export const getGetMatchGroupProjectPlanQueryOptions = <
  TData = Awaited<ReturnType<typeof getMatchGroupProjectPlan>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchGroupProjectPlan>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMatchGroupProjectPlanQueryKey(matchGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchGroupProjectPlan>>> = ({
    signal,
  }) => getMatchGroupProjectPlan(matchGroupId, signal);

  return { queryKey, queryFn, enabled: !!matchGroupId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMatchGroupProjectPlan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMatchGroupProjectPlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMatchGroupProjectPlan>>
>;
export type GetMatchGroupProjectPlanQueryError = void | HTTPValidationError;

export function useGetMatchGroupProjectPlan<
  TData = Awaited<ReturnType<typeof getMatchGroupProjectPlan>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchGroupProjectPlan>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMatchGroupProjectPlan>>,
          TError,
          Awaited<ReturnType<typeof getMatchGroupProjectPlan>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMatchGroupProjectPlan<
  TData = Awaited<ReturnType<typeof getMatchGroupProjectPlan>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchGroupProjectPlan>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMatchGroupProjectPlan>>,
          TError,
          Awaited<ReturnType<typeof getMatchGroupProjectPlan>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMatchGroupProjectPlan<
  TData = Awaited<ReturnType<typeof getMatchGroupProjectPlan>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchGroupProjectPlan>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Match Group Project Plan
 */

export function useGetMatchGroupProjectPlan<
  TData = Awaited<ReturnType<typeof getMatchGroupProjectPlan>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchGroupProjectPlan>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMatchGroupProjectPlanQueryOptions(matchGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
